import moment from 'moment';

export default date => (date instanceof moment ? date : moment(date));
